import { Routes } from '@angular/router';
import { loggedInAuthGuard } from '@guards/logged-in-auth.guard';

export const APP_ROUTES: Routes = [
  {
    path: '',
    children: [
      {
        path: 'm',
        loadChildren: () =>
          import('./features/mobile/mobile.routes').then(
            (m) => m.MOBILE_ROUTES,
          ),
      },
      {
        path: 'd',
        loadChildren: () =>
          import('./features/desktop/desktop.routes').then(
            (m) => m.DESKTOP_ROUTES,
          ),
      },
    ],
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'error',
    loadComponent: () =>
      import('./features/error/error.component').then((m) => m.ErrorComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
